<template>
  <div class="block bg-white d-flex flex-column align-items-end">
    <div class="common-modal-header number-modal-header d-flex flex-column align-items-start">
      <div class="default-column-name">
        <span class="default-column-title"> {{columnName}} </span>
      </div>
      <div v-if="!disableChangeColumnName" class="editLabel d-flex flex-row align-items-center" @click="onEditLabelHeader">
        <div class="optionEditLabel">
          <i class="material-icons material-icons-outlined icon_edit">
            edit
          </i>
          <span class="text">表示名を変更</span>
        </div>
      </div>
      <div v-if="!disableChangeColumnName" class="line"></div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 1 },
          'sortByAsc d-flex flex-row align-items-center'
        ]"
        @click="onSortByAsc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_upward">
            arrow_upward
          </i>
          <span class="text">A to Zで並べ替え</span>
        </div>
      </div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 2 },
          'sortByDesc d-flex flex-row align-items-center'
        ]"
        @click="onSortByDesc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_downward">
            arrow_downward
          </i>
          <span class="text">Z to Aで並べ替え</span>
        </div>
      </div>
    </div>
    <div v-if="!hideSortOrder" class="line"></div>
    <div
      class="
        number-modal-body
        d-flex
        flex-row
        align-items-center
        justify-content-center
      "
    >
    <!-- BEFORE INPUT -->
      <input
        type="number"
        onkeydown="return (event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 188 && event.keyCode !== 190 && event.keyCode !== 187)"
        @keydown.enter="onSubmit"
        class="form-control"
        v-model.number="form.beforeNumber"
      />
      <label class="iconBetween text-center">&#126;</label>
      <!-- AFTER INPUT -->
      <input
        type="number"
        onkeydown="return (event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 188 && event.keyCode !== 190 && event.keyCode !== 187)"
        @keydown.enter="onSubmit"
        class="form-control"
        v-model.number="form.afterNumber"
      />
    </div>
    <div
      class="
        number-modal-footer
        d-flex
        flex-row
        align-items-center
        justify-content-center
      "
    >
      <b-button variant="info" @click.prevent="onSubmit" class="btnSubmit">
        OK
      </b-button>
    </div>
  </div>
</template>

<script>
const SORT_ASC_MODE = 1
const SORT_DESC_MODE = 2
export default {
  data() {
    return {
      query: {},
      form: {
        isItemNo: this.isItemNo,
        sortBy: -1,
        beforeNumber: '',
        afterNumber: ''
      },
      columnName: this.defaultItemName
    }
  },
  props: ['isItemNo', 'queryPrameterValue', 'defaultItemName', 'disableChangeColumnName', 'hideSortOrder'],
  watch: {
    isItemNo: {
      handler: function (newValue, oldValue) {
        this.form.isItemNo = newValue
      }
    },
    queryPrameterValue: {
      handler: function (newValue, oldValue) {
        if (newValue[`before_${this.form.isItemNo}`] || newValue[`after_${this.form.isItemNo}`]) {
          this.form.beforeNumber = newValue[`before_${this.form.isItemNo}`]
          this.form.afterNumber = newValue[`after_${this.form.isItemNo}`]
        }
      },
      deep: true
    }
  },
  methods: {
    resetValueComponent() {
      this.form.beforeNumber = this.queryPrameterValue[`before_${this.form.isItemNo}`]
      this.form.afterNumber = this.queryPrameterValue[`after_${this.form.isItemNo}`]
    },
    initValueComponent(sort, isItemNo) {
      this.form.beforeNumber = this.queryPrameterValue[`before_${isItemNo}`]
      this.form.afterNumber = this.queryPrameterValue[`after_${isItemNo}`]
      if (sort.propetyName === isItemNo) {
        this.form.sortBy = sort.order
      } else {
        this.form.sortBy = -1
      }
    },
    onSortByAsc() {
      this.form.sortBy = this.toggleSort(SORT_ASC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    onSortByDesc() {
      this.form.sortBy = this.toggleSort(SORT_DESC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    onSubmit() {
      this.queryPrameterValue[`before_${this.form.isItemNo}`] = this.form.beforeNumber
      this.queryPrameterValue[`after_${this.form.isItemNo}`] = this.form.afterNumber
      this.$emit('on-submit', this.queryPrameterValue)
    },
    onEditLabelHeader() {
      this.$emit('allow-edit-label')
    },
    toggleSort(value) {
      if (this.form.sortBy !== value) {
        return value
      }
      return null
    },
    getPropertyNameBySort(sortBy) {
      return sortBy ? this.form.isItemNo : null
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  padding: 4px 1px 4px 8px;
  width: 280px;
  height: auto;
  cursor: default;
}
input[type='number'] {
  width: 112px;
}
.number-modal-header {
  left: 8px;
  top: 4px;
}
.line {
  width: 272px;
  height: 1px;
  left: 8px;
  top: 92px;
  margin: 8px 0;
  background: $line_gray;
}
.number-modal-body {
  padding: 8px 8px 8px 4px;
  width: 272px;
  min-height: 54px;
}
.iconBetween {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(16);
  line-height: 24px;
  width: 30px;
  margin-bottom: 0;
}
.number-modal-footer {
  padding: 8px;
  width: 272px;
  height: 58px;
  .btnCancel {
    padding-right: 35px;
    font-style: normal;
    font-weight: normal;
    @include responsive-fs(12);
    line-height: 160%;
    color: #4e66a6;
    &:hover {
      text-decoration: none;
    }
  }
  .active {
    background-color: #67a3c7;
    color: #ffffff;
  }
}
.arrow_downward, .arrow_upward {
  @include responsive-fs(15);
}
.icon_edit {
  @include responsive-fs(14);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/NumberFilterSortModal.vue